<script setup lang="ts">

import { faArrowUpRight, faClone, faListCheck, faMerge, faTrash, faUserPen } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useDisciplineActions } from '../model/discipline-actions.hook'

defineOptions({
  name: 'DisciplineActions',
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManageDisciplines,
  canDeleteDisciplines,
  refIsTasksVisible,
  refHasTutor,
  toggle,
  openChangeTutor,
  openDuplicate,
  openMerge,
  openDelete,
  openCreateTask,
  openRelatedTasks,
} = useDisciplineActions()
</script>

<template>
  <div
    v-if="canManageDisciplines || canDeleteDisciplines"
    ref="containerRef"
    class="discipline-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      title="Discipline actions"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="discipline-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          v-if="canManageDisciplines"
          text="Change tutor"
          color="blue"
          :prepend-icon="faUserPen"
          :disabled="!refHasTutor"
          @click="openChangeTutor"
        />
        <AppDropdownItem
          v-if="canManageDisciplines"
          text="Duplicate discipline"
          color="blue"
          :prepend-icon="faClone"
          @click="openDuplicate"
        />
        <AppDropdownItem
          v-if="canManageDisciplines"
          text="Merge into this discipline"
          color="blue"
          :prepend-icon="faMerge"
          @click="openMerge"
        />
        <AppDropdownItem
          v-if="canManageDisciplines && refIsTasksVisible"
          text="Create task"
          color="blue"
          :prepend-icon="faListCheck"
          @click="openCreateTask"
        />
        <AppDropdownItem
          v-if="canManageDisciplines && refIsTasksVisible"
          text="View related tasks"
          color="blue"
          :prepend-icon="faArrowUpRight"
          @click="openRelatedTasks"
        />
        <AppDropdownItem
          v-if="canDeleteDisciplines"
          text="Delete discipline"
          color="red"
          :prepend-icon="faTrash"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineActions.scss" />
